import ActionsForm from '@/shared/mixins/actionsForm'
import CompanyMixin from '@/store/module/company/mixin'
import Form from './pdrreportevaluationmember-form'
import Data from '@/shared/models/pci/pdrreportvaluationmembermodel'
import PdrReportEvaluationMemberRepository from '@/shared/http/repositories/pci/pdrrelatoriomedia'
import { loading, toast } from '@/shared/utils/UIHelper'
import EmployeeRepository from '@/shared/http/repositories/business/employee'

export default {
  name: 'PdrReportEvaluationMember',
  mixins: [ActionsForm, CompanyMixin],
  components: {

  },
  data () {
    return {
      isEditing: false,
      dataInicioReport: null,
      dataFimReport: null,
      objList: [],
      form: Form,
      data: Data,
      selected: null,
      memberList: []
    }
  },
  methods: {
    onLoad () {
      loading.push()
      this.onClearForm()
      PdrReportEvaluationMemberRepository.GetAll(this.company.id, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then(response => {
          if (response.data.code > 0) {
            this.onResultGrid(response)
          } else {
            toast.error(this.$lang.Common.CouldNotLoadRegister)
          }
        })
        .catch(err => this.onException(err))

      EmployeeRepository.GetAllPdr(this.company.id)
        .then(response => {
          if (response.data.code > 0) {
            this.memberList = response.data.data
          }
        })
        .finally(() => loading.close())
    },
    onSelect (data) {
      this.isEditing = true
      this.onEdit(data)
      this.$refs.txtDescricao.$el.focus()
    },
    onCreate () {
      this.createOrUpdate()
    },
    onUpdate () {
      this.createOrUpdate()
    },
    createOrUpdate () {
      if (this.data.pdrRelatorioMediaFuncionario === null || this.data.pdrRelatorioMediaFuncionario.length === 0) {
        toast.error(this.$lang.PCI.ReportEvaluation.PlaceholderMemberDescription)
        return
      }
      loading.push()
      PdrReportEvaluationMemberRepository.Create(this.company.id, this.data)
        .then(response => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.onClear()
            this.onLoad()
          } else {
            toast.error(response.data.message || this.$lang.Common.CouldNotSave)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onDelete (item) {
      loading.push()
      PdrReportEvaluationMemberRepository.Delete(item.id)
        .then(response => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.onClear()
            this.onLoad()
          } else {
            toast.error(response.data.message || this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onNewMember () {
      if (this.selected) {
        if (this.data.pdrRelatorioMediaFuncionario == null) {
          this.data.pdrRelatorioMediaFuncionario = []
        }
        if (!this.data.pdrRelatorioMediaFuncionario.some(x => x.funcionarioID === this.selected.funcionarioID)) {
          this.data.pdrRelatorioMediaFuncionario.push({funcionarioID: this.selected.id, funcionario: this.selected})
        }
        this.selected = null
      }
    },
    onRemoveMember (member) {
      this.data.pdrRelatorioMediaFuncionario = this.data.pdrRelatorioMediaFuncionario.filter((el) => el.id !== member.id)
    },
    onClearFilters () {
      this.dataInicioReport = null
      this.dataFimReport = null
    },
    onPrint (obj) {
      loading.push()
      PdrReportEvaluationMemberRepository.PrintReport(this.company.id, obj)
        .then(response => {
          if (response.data.code > 0) {
            const binary = window.atob(response.data.data.replace(/\s/g, ''))
            const len = binary.length
            const buffer = new ArrayBuffer(len)
            const view = new Uint8Array(buffer)
            for (let i = 0; i < len; i++) {
              view[i] = binary.charCodeAt(i)
            }
            const blob = new Blob([view], {type: 'application/pdf'})

            const fileURL = URL.createObjectURL(blob)
            window.open(fileURL)
          }
        })
        .catch(error => {
          console.log(error)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    onClearForm () {
      this.onClear()
      this.isEditing = false
      this.selected = null
    },
    onSaveForm () {
      this.onSave()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/reports/pdrreportevaluationmember/pdrreportevaluationmember.js